import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import SimpleCard from '../../../../components/SimpleCard';
import { formatDate, formatTime } from '../../../../utils';

export default function InfoEventCard({ event }) {
  if (!event?.id) return <p>No event to display</p>;
  const parametersEvent = event?.parameters_event;
  return (
    <SimpleCard variant="outlined">
      <div
        style={{
          // backgroundImage: 'url(http://mymfoodservice.com/img_catering/catering_1.jpg)',
          borderRadius: '1rem',
          paddingBottom: '1rem',
        }}>
        <Grid container textAlign="center">
          <Grid item xs>
            <h2>{event.name}</h2>
            <div>{event.event_price}</div>
            <div>{event.street_address}</div>
            <div>{event.description}</div>
          </Grid>
        </Grid>
        {parametersEvent?.id && (
          <>
            <Grid container textAlign="center">
              <Grid item xs>
                <Typography>{formatDate(parametersEvent.event_date)}</Typography>
              </Grid>
            </Grid>
            <Grid container textAlign="center">
              <Grid item xs>
                <div>
                  <span>{formatTime(parametersEvent.hour_start_event)}</span>
                  <span style={{ padding: '0 1rem' }}>to</span>
                  <span>{formatTime(parametersEvent.hour_end_event)}</span>
                </div>
              </Grid>
            </Grid>
          </>
        )}
      </div>
    </SimpleCard>
  );
}

InfoEventCard.propTypes = {
  event: PropTypes.instanceOf(Object),
};

InfoEventCard.defaultProps = {
  event: {},
};
